"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreBiographicInfoStepOverrideReasonEnum = exports.PreBiographicInfoStepToJSON = exports.PreBiographicInfoStepFromJSONTyped = exports.PreBiographicInfoStepFromJSON = void 0;
const runtime_1 = require("../runtime");
function PreBiographicInfoStepFromJSON(json) {
    return PreBiographicInfoStepFromJSONTyped(json, false);
}
exports.PreBiographicInfoStepFromJSON = PreBiographicInfoStepFromJSON;
function PreBiographicInfoStepFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'firstName': json['firstName'],
        'middleName': !runtime_1.exists(json, 'middleName') ? undefined : json['middleName'],
        'noMiddleName': json['noMiddleName'],
        'lastName': json['lastName'],
        'suffix': !runtime_1.exists(json, 'suffix') ? undefined : json['suffix'],
        'gender': json['gender'],
        'dateOfBirth': !runtime_1.exists(json, 'dateOfBirth') ? undefined : (new Date(json['dateOfBirth'])),
        'overrideReason': !runtime_1.exists(json, 'overrideReason') ? undefined : json['overrideReason'],
    };
}
exports.PreBiographicInfoStepFromJSONTyped = PreBiographicInfoStepFromJSONTyped;
function PreBiographicInfoStepToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'firstName': value.firstName,
        'middleName': value.middleName,
        'noMiddleName': value.noMiddleName,
        'lastName': value.lastName,
        'suffix': value.suffix,
        'gender': value.gender,
        'dateOfBirth': value.dateOfBirth === undefined ? undefined : (value.dateOfBirth.toISOString().substr(0, 10)),
        'overrideReason': value.overrideReason,
    };
}
exports.PreBiographicInfoStepToJSON = PreBiographicInfoStepToJSON;
/**
* @export
* @enum {string}
*/
var PreBiographicInfoStepOverrideReasonEnum;
(function (PreBiographicInfoStepOverrideReasonEnum) {
    PreBiographicInfoStepOverrideReasonEnum["ALTEREDTOMEETTSANAMEREQUIREMENTS"] = "ALTERED_TO_MEET_TSA_NAME_REQUIREMENTS";
    PreBiographicInfoStepOverrideReasonEnum["MULTIPLENAMESINASINGLEFIELD"] = "MULTIPLE_NAMES_IN_A_SINGLE_FIELD";
    PreBiographicInfoStepOverrideReasonEnum["NAMETRUNCATED"] = "NAME_TRUNCATED";
    PreBiographicInfoStepOverrideReasonEnum["OCRINCORRECT"] = "OCR_INCORRECT";
})(PreBiographicInfoStepOverrideReasonEnum = exports.PreBiographicInfoStepOverrideReasonEnum || (exports.PreBiographicInfoStepOverrideReasonEnum = {}));
//# sourceMappingURL=PreBiographicInfoStep.js.map